import 'react';
import { jsx } from 'react/jsx-runtime';
var AUSSIE_IS_SCRIPTS = {
  development: /*#__PURE__*/jsx("script", {
    type: "text/javascript",
    src: "https://cdn.evgnet.com/beacon/auscred/aussie_dev/scripts/evergage.min.js"
  }),
  staging: /*#__PURE__*/jsx("script", {
    type: "text/javascript",
    src: "https://cdn.evgnet.com/beacon/auscred/aussiestaging/scripts/evergage.min.js"
  }),
  preproduction: /*#__PURE__*/jsx("script", {
    type: "text/javascript",
    src: "https://cdn.evgnet.com/beacon/auscred/aussiestaging/scripts/evergage.min.js"
  }),
  production: /*#__PURE__*/jsx("script", {
    type: "text/javascript",
    src: "https://cdn.evgnet.com/beacon/auscred/aussieproduction/scripts/evergage.min.js"
  })
};
var LENDI_IS_SCRIPTS = {
  development: /*#__PURE__*/jsx("script", {
    type: "text/javascript",
    src: "https://cdn.evgnet.com/beacon/auscred/dev/scripts/evergage.min.js"
  }),
  staging: /*#__PURE__*/jsx("script", {
    type: "text/javascript",
    src: "https://cdn.evgnet.com/beacon/auscred/staging/scripts/evergage.min.js"
  }),
  preproduction: /*#__PURE__*/jsx("script", {
    type: "text/javascript",
    src: "https://cdn.evgnet.com/beacon/auscred/staging/scripts/evergage.min.js"
  }),
  production: /*#__PURE__*/jsx("script", {
    type: "text/javascript",
    src: "https://cdn.evgnet.com/beacon/auscred/production/scripts/evergage.min.js"
  })
};
export { AUSSIE_IS_SCRIPTS, LENDI_IS_SCRIPTS };